/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CoursefinancialCoursefinancialidLangs200,
  GetApiV1CoursefinancialCoursefinancialidLangs400,
  GetApiV1CoursefinancialCoursefinancialidLangs401,
  GetApiV1CoursefinancialCoursefinancialidLangs404,
  GetApiV1CoursefinancialCoursefinancialidLangs500,
  GetApiV1CoursefinancialCoursefinancialidLangsPathParams,
  GetApiV1CoursefinancialCoursefinancialidLangsQueryParams,
  GetApiV1CoursefinancialCoursefinancialidLangsQueryResponse,
} from "../../types/courseFinancialLangsController/GetApiV1CoursefinancialCoursefinancialidLangs.ts";
import { courseFinancialLangViewModelPaginatedResponseSchema } from "../courseFinancialLangViewModelPaginatedResponseSchema.ts";

export const getApiV1CoursefinancialCoursefinancialidLangsPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsPathParams>;

export const getApiV1CoursefinancialCoursefinancialidLangsQueryParamsSchema =
  z.object({
    Search: z.optional(
      z
        .string()
        .describe("Texto livre aplicado à descrição do plano. Opcional."),
    ),
    Active: z.optional(
      z
        .boolean()
        .describe(
          "Filtra por situação do plano. Quando omitido, retorna ativos e inativos. No legado esse filtro era aplicado apenas no grid.",
        ),
    ),
    PageNumber: z.coerce
      .number()
      .int()
      .default(1)
      .describe("Página da listagem. Mínimo 1."),
    PageSize: z.coerce
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  }) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CoursefinancialCoursefinancialidLangs200Schema = z.lazy(
  () => courseFinancialLangViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangs200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CoursefinancialCoursefinancialidLangs400Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CoursefinancialCoursefinancialidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CoursefinancialCoursefinancialidLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CoursefinancialCoursefinancialidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangs500>;

export const getApiV1CoursefinancialCoursefinancialidLangsQueryResponseSchema =
  z.lazy(
    () => getApiV1CoursefinancialCoursefinancialidLangs200Schema,
  ) as unknown as ToZod<GetApiV1CoursefinancialCoursefinancialidLangsQueryResponse>;
